//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { getTargetSetFromStore } from '../helpers'

const useOptionsFromState = targetSet => {
  const dispatch = useDispatch()

  return useMemo(() => (
    dispatch(getTargetSetFromStore(targetSet))
  ), [targetSet])
}

export default useOptionsFromState
